import { createFileRoute } from '@tanstack/react-router';
import { SsoTenantLogin } from '../../components';

export const Route = createFileRoute('/sso/')({
  component: SsoTenantWithoutRouteParam,
});

function SsoTenantWithoutRouteParam() {
  const navigate = Route.useNavigate();

  return <SsoTenantLogin<`/sso`> {...{ navigate }} />;
}
